//KardexContainer Develop 
import React, { useEffect, useState } from 'react';

import IconButton from '@material-ui/core/IconButton';
import { Tooltip, Input, Button, Icon } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCommunicationStatus, clearCommunicationStatus } from 'app/actions/CommunicationStatusActions';
import { getCommunicationStatus, getIsLoadingCommunicationStatus } from 'app/reducers';
import * as UserSearchActions from 'app/actions/UserSearchActions';
import { useStyles, styles } from '../KardexScreenStyles'
import moment from 'moment';
import Highlighter from 'react-highlight-words';
import isEmpty from 'app/utils/IsEmpty';

export default function KardexContainer(props) {
    const classes = useStyles();
    const pagination = props.pagination;
    const sorter = props.sorter;
    const filterKardex = props.filterKardex;
    let offset = 0;
    let limit = 0;
    let column = 'courseCode';
    let order = 'ASC';
    const [dataToExport, setDataToExport] = useState([]);
    const [isFiltering, setIsFiltering] = useState(false);


    //Datos del store de redux
    const {
        isLoadingKardex,
        listKardex
    } = useSelector(state => state.UserSearchReducer);

    //Estado para busqueda
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');

    //Helpers table search
    const handleSearch = (selectedKeys, confirm, dataIndex, listKardex) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
        setIsFiltering(true);
        // if(dataToExport.length>0){
        //     setDataToExport(dataToExport.filter(x => x[dataIndex].toLowerCase().indexOf(selectedKeys[0].toLocaleLowerCase())>-1))
        // }else{
        // setDataToExport(listKardex.filter(x => x[dataIndex].toLowerCase().indexOf(selectedKeys[0].toLocaleLowerCase())>-1));
        // }
    }

    const handleReset = clearFilters => {
        clearFilters();
        setSearchText('');
        setIsFiltering(false);
        setDataToExport([]);
    };

    //Genera la estructura de búsqueda
    const getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input

                    placeholder={`Buscar...`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                    type="primary"
                    onClick={() => handleSearch(selectedKeys, confirm, dataIndex, listKardex)}
                    icon="search"
                    size="small"
                    style={{ width: 90, marginRight: 8 }}
                >
                    Buscar
                </Button>
                <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                    Limpiar
                </Button>
            </div>
        ),
        filterIcon: filtered => (
            <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
                : '',
        // if(record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()))
        //     dataToExport.push(record);
        // return record[dataIndex]
        //     .toString()
        //     .toLowerCase()
        //     .includes(value.toLowerCase())
        // },
        render: text =>
            searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                    searchWords={[searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ''}
                />
            ) : (
                text
            ),
    });

    const columns = [
        {
            title: <div>Cod. Procedimiento/Material<br></br>de Capacitación</div>,
            dataIndex: 'courseCode',
            key: 'courseCode',
            sorter: true,
            width: 250,
            ellipsis: true,
            ...getColumnSearchProps('courseCode')
        },
        {
            title: <div>Nombre Procedimiento/Material<br></br>de Capacitación</div>,
            dataIndex: 'courseName',
            key: 'courseName',
            sorter: true,
            width: 300,
            ellipsis: true,
            ...getColumnSearchProps('courseName')
        },
        {
            title: 'PDC',
            dataIndex: 'communicationProgramName',
            key: 'communicationProgramName',
            sorter: true,
            width: 250,
            ellipsis: true,
            ...getColumnSearchProps('communicationProgramName'),
            // render: (id, i) => {
            //     return <div>
            //         <Tooltip placement="bottomLeft" title={id}>
            //             {id}
            //         </Tooltip>
            //     </div>
            // }
        },
        {
            title: 'Tipo de Capacitación',
            dataIndex: 'trainingName',
            key: 'trainingName',
            sorter: true,
            width: 250,
            ellipsis: true,
            ...getColumnSearchProps('trainingName')
        },
        {
            title: 'Especialidad/Sistema',
            dataIndex: 'especialtyOrSystem',
            key: 'especialtyOrSystem',
            sorter: true,
            width: 250,
            ellipsis: true,
            ...getColumnSearchProps('especialtyOrSystem')
        },
        {
            title: 'Contrato',
            dataIndex: 'contractName',
            key: 'contractName',
            sorter: true,
            width: 250,
            ellipsis: true,
            ...getColumnSearchProps('contractName')
        },
        {
            title: 'Obra',
            dataIndex: 'ot',
            key: 'ot',
            sorter: true,
            width: 250,
            ellipsis: true,
            ...getColumnSearchProps('ot')
        },
        {
            title: 'Estatus',
            dataIndex: 'statusName',
            key: 'statusName',
            sorter: true,
            width: 250,
            ellipsis: true,
            ...getColumnSearchProps('statusName')
        },
        {
            title: <div>Fecha Programada<br></br>de Inicio</div>,
            dataIndex: 'diffusionStartDate',
            key: 'diffusionStartDate',
            sorter: true,
            width: 250,
            ellipsis: true,
            ...getColumnSearchProps('diffusionStartDate'),
            // render: (date) => {
            //     return moment(new Date(date)).locale('es').format('L')
            // }
        },
        {
            title: <div>Fecha Programada<br></br>de Finalización</div>,
            dataIndex: 'diffusionEndDate',
            key: 'diffusionEndDate',
            sorter: true,
            width: 250,
            ellipsis: true,
            ...getColumnSearchProps('diffusionEndDate'),
            // render: (date) => {
            //     return moment(new Date(date)).locale('es').format('L')
            // }
        },
        {
            title: <div>Fecha Evaluación<br></br>Teórica</div>,
            dataIndex: 'dateTest',
            key: 'dateTest',
            sorter: true,
            width: 250,
            ellipsis: true,
            ...getColumnSearchProps('dateTest'),
            // render: (date) => {
            //     if (date !== 'N/A' && date !== '---')
            //         return moment(new Date(date)).locale('es').format('L')
            //     else
            //         return date
            // }
        },
        {
            title: 'Fecha Evaluación CT',
            dataIndex: 'dateCT',
            key: 'dateCT',
            sorter: true,
            width: 250,
            ellipsis: true,
            ...getColumnSearchProps('dateCT'),
            // render: (date) => {
            //     if (date !== 'N/A' && date !== '---')
            //         return moment(new Date(date)).locale('es').format('L')
            //     else
            //         return date
            // }
        },
        {
            title: 'Evaluación',
            dataIndex: 'testResult',
            key: 'testResult',
            sorter: true,
            width: 250,
            ellipsis: true,
            ...getColumnSearchProps('testResult')
        },
        {
            title: <div>Fecha Última<br></br>Notificación</div>,
            dataIndex: 'dateNotify',
            key: 'dateNotify',
            sorter: true,
            width: 250,
            ellipsis: true,
            ...getColumnSearchProps('dateNotify'),
            // render: (date) => {
            //     if (date !== 'N/A' && date !== '---')
            //         return moment(new Date(date)).locale('es').format('L')
            //     else
            //         return date
            // }
        },
        // {
        //     title: 'Acciones',
        //     key: 'action',
        //     dataIndex: 'employeeId',
        //     fixed: 'right',
        //     // width: '100%',
        //     render: (text, record) => (
        //         record.statusName === 'Aprobado'
        //             ? <div className={classes.buttons}>
        //                 <Tooltip placement="bottom" title={'Descargar Comunicación'}>
        //                     <IconButton onClick={() => props.exportSingleGenerate(record)}>
        //                         <Icon type="download" />
        //                     </IconButton>
        //                 </Tooltip>
        //             </div> : null
        //     )
        // }
    ];

    const columnsExport = [
        {
            label: 'Cod. Procedimiento/Material de Capacitación',
            key: 'courseCode'
        },
        {
            label: 'Nombre Procedimiento/Material de Capacitación',
            key: 'courseName'
        },
        {
            label: 'PDC',
            key: 'communicationProgramName'
        },
        {
            label: 'Tipo de Capacitación',
            key: 'trainingName'
        },
        {
            label: 'Especialidad/Sistema',
            key: 'especialtyOrSystem'
        },
        {
            label: 'Contrato',
            key: 'contractName'
        },
        {
            label: 'Obra',
            key: 'OT'
        },
        {
            label: 'Estatus',
            key: 'statusName'
        },
        {
            label: 'Fecha Programada de Inicio',
            key: 'diffusionStartDate'
        },
        {
            label: 'Fecha Programada de Finalización',
            key: 'diffusionEndDate'
        },
        {
            label: 'Fecha Evaluación Teórica',
            key: 'dateTest'
        },
        {
            label: 'Fecha Evaluación CT',
            key: 'dateCT'
        },
        {
            label: 'Evaluación',
            key: 'testResult'
        },
        {
            label: 'Fecha Última Notificación',
            key: 'dateNotify'
        }
    ];

    let communicationProgram = useSelector(getCommunicationStatus);

    let isLoading = useSelector(getIsLoadingCommunicationStatus);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(clearCommunicationStatus());
        fetchCommunicationStatusAction();
    }, []);

    const handleTableChange = (pagination, filters, sorter) => {
        props.setPagination(pagination);
        props.setSorter(sorter);
        props.setFilterKardex(filters);

        if (Object.keys(sorter).length > 0) {
            column = sorter.field;
            order = sorter.order === "ascend" ? "ASC" : "DESC";
        }
        else {
            column = 'courseCode';
            order = 'ASC';
        }
        dispatch(fetchCommunicationStatus(props.idEmployee,
            {
                sortColumn: column,
                sortDir: order,
                offset: ((pagination.current - 1) * pagination.pageSize),
                limit: pagination.pageSize
            }));

        dispatch(UserSearchActions.fetchKardex({
            employeeId: props.idEmployee,
            nameEmployee: '',
            courseCode: filters.courseCode != undefined ? filters.courseCode.length > 0 ? filters.courseCode[0] : '' : '',
            courseName: filters.courseName != undefined ? filters.courseName.length > 0 ? filters.courseName[0] : '' : '',
            communicationProgramName: filters.communicationProgramName != undefined ? filters.communicationProgramName.length > 0 ? filters.communicationProgramName[0] : '' : '',
            trainingName: filters.trainingName != undefined ? filters.trainingName.length > 0 ? filters.trainingName[0] : '' : '',
            especialtyOrSystem: filters.especialtyOrSystem != undefined ? filters.especialtyOrSystem.length > 0 ? filters.especialtyOrSystem[0] : '' : '',
            contractName: filters.contractName != undefined ? filters.contractName.length > 0 ? filters.contractName[0] : '' : '',
            ot: filters.ot != undefined ? filters.ot.length > 0 ? filters.ot[0] : '' : '',
            statusName: filters.statusName != undefined ? filters.statusName.length > 0 ? filters.statusName[0] : '' : '',
            diffusionStartDate: filters.diffusionStartDate != undefined ? filters.diffusionStartDate.length > 0 ? filters.diffusionStartDate[0] : '' : '',
            diffusionEndDate: filters.diffusionEndDate != undefined ? filters.diffusionEndDate.length > 0 ? filters.diffusionEndDate[0] : '' : '',
            dateTest: filters.dateTest != undefined ? filters.dateTest.length > 0 ? filters.dateTest[0] : '' : '',
            dateCT: filters.dateCT != undefined ? filters.dateCT.length > 0 ? filters.dateCT[0] : '' : '',
            destResult: filters.destResult != undefined ? filters.destResult.length > 0 ? filters.destResult[0] : '' : '',
            dateNotify: filters.dateNotify != undefined ? filters.dateNotify.length > 0 ? filters.dateNotify[0] : '' : '',
            sortColumn: column,
            sortDir: order,
            offset: ((pagination.current - 1) * pagination.pageSize),
            limit: pagination.pageSize
        }));
    };
    //Load
    if (pagination != null) {
        offset = (0 * pagination.pageSize);
        limit = (pagination.pageSize);

        if (!isLoadingKardex && listKardex.length > 0) {
            pagination.total = listKardex[0].totalCount;
        }
        else {
            pagination.total = 0;
        }
    }

    if (sorter.field) {
        column = sorter.field;
        order = sorter.order === "ascend" ? "ASC" : "DESC";
    }

    const fetchCommunicationStatusAction = () => {
        dispatch(fetchCommunicationStatus(props.idEmployee, {
            sortColumn: column,
            sortDir: order, offset: offset, limit: limit
        }));

        dispatch(UserSearchActions.fetchKardex({
            employeeId: props.idEmployee,
            sortColumn: column,
            sortDir: order, offset: offset, limit: limit
        }));
    }

    const dataExport = [...new Set(dataToExport.map(i => i))];

    return (props.children({ pagination: pagination, cols: columns, communicationProgram, isLoading, handleTableChange: handleTableChange, isLoadingKardex, listKardex: listKardex.map(e => { return { ...e, key: e.rowNum } }), dataToExport, columnsExport, isFiltering }));
}
